import React from 'react';

class AppExt extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return <div>
      {this.props.children}
    </div>;
  }
}

export default AppExt;


// WEBPACK FOOTER //
// ./src/components/common/AppExt.jsx